import React, { useEffect, useState } from "react";
import Navnav from "../../Navnav/Navnav";
import { BsCalendar, BsFlag } from "react-icons/bs";
import dayjs from "dayjs";
import Carousel from "../../../components/bootstrap/Carousel";
import Card, { CardBody } from "../../../components/bootstrap/Card";
import DataImage from "../../../assets/img/landing2/vide.webp";
import { globalT } from "../../../lang";
import Footfoot from "../../Navnav/Footfoot";
import { Campagne } from "../../../commons/models/Campagne";
import { useAppDispatch } from "../../../store/redux.types";
import { useParams } from "react-router-dom";
import { setRequestGlobalLoader } from "../../../store/slices/requestGlobalLoader/actions";
import mintClient from "../../../network";
import { Evenements } from "../../../commons/models/Evenements";

const DetailEv = () => {
  const [evenement, setEvenement] = useState<Evenements | null>(null);
  const [attachment, setAttachment] = useState<object[] | null>();
  const dispatch = useAppDispatch();
  const EvenementId = useParams().id;
  const loadCampagne = () => {
    if (!EvenementId) return;
    // dispatch(setRequestGlobalLoader(true))
    mintClient.evenement
      .getOne(EvenementId as string)
      .then((resp) => {
        const allData = resp.data.data;
        const itemCarousel = allData.attachments.map((attachment: any) => ({
          src: attachment.attachmentFile,
          type: attachment.attachmentTypeName,
          isDetail: true,
        }));
        setAttachment(itemCarousel);
        setEvenement(allData);
      })
      .catch((error) => null)
      .finally(() => dispatch(setRequestGlobalLoader(false)));
  };

  useEffect(() => {
    loadCampagne();
  }, []);

  return (
    <>
      <Navnav />
      <div className="container">
        {evenement ? (
          <div className="mb-3" style={{ marginTop: "150px" }}>
            <div className="pt-2 pb-3 d-flex flex-column align-items-start">
              <h1 className="display-4 fw-bold me-3">{evenement.name}</h1>
            </div>
            <div style={{ marginBottom: "30px", marginLeft: "20px" }}>
              <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                <span>
                  <BsFlag color="red" />
                </span>
                <span>
                  {" "}
                  Type d'évenement :{" "}
                  {evenement.type === 0 ? "Atélier" : "Séminaire"}
                </span>
              </p>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  marginTop: "10px",
                }}
              >
                <span>
                  <BsCalendar color="blue" />
                </span>
                <span>
                  {" "}
                  Evenement mise à jour le :{" "}
                  {dayjs(evenement.endDate).format("DD/MM/YYYY")}
                </span>
              </p>
            </div>
            <div className="row pb-4">
              {attachment && (
                <div>
                  <div className="col-10 align-items-center-center ps-3 pb-3 ">
                    <Carousel items={attachment} isControl={true} />
                  </div>
                </div>
              )}
              <div
                style={{ marginLeft: "-8%" }}
                className="d-flex justify-content-center"
              >
                <div
                  style={{ fontWeight: "bold", borderRadius: "8px" }}
                  className=" top-5 end-5 bg-danger text-warning p-2"
                >
                  Début : {dayjs(evenement.startDate).format("DD/MM/YYYY")}
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    borderRadius: "8px",
                    marginLeft: "20px",
                  }}
                  className=" top-5 end-5 bg-danger text-warning p-2"
                >
                  Fin : {dayjs(evenement.endDate).format("DD/MM/YYYY")}
                </div>
              </div>

              <div className="des mt-4">
                <Card
                  style={{
                    marginLeft: "10px",
                    width: "120%",
                    marginTop: "20px",
                  }}
                >
                  <CardBody
                    style={{
                      height: "300px",
                      overflow: "auto",
                      fontSize: "15px",
                    }}
                  >
                    {evenement.description}
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        ) : (
          <div className="imageContainer" style={{ marginTop: "100px" }}>
            <div className="text-center mt-5 mb-5">
              <div
                style={{
                  width: "400px", // or any size you want
                  height: "400px", // make it a square
                  backgroundImage: `url(${DataImage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  margin: "0 auto", // this will center the div if the parent div has a text-align: center
                }}
                className="image"
              />
              <div className="d-flex justify-content-center spinnerContainer">
                <div
                  className="spinner-border"
                  style={{
                    height: "6rem",
                    width: "6rem",
                    color: "#aae0aa",
                    marginTop: "85px",
                    marginRight: "15px",
                  }}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              <span
                className="fw-bold"
                style={{
                  marginTop: "20px",
                  fontSize: "24px",
                }}
              >
                {globalT("empty.event")}
              </span>
            </div>
          </div>
        )}
      </div>
      <Footfoot />
    </>
  );
};

export default DetailEv;
